import React, {memo} from 'react';

import {
  StoichiometryStructuredTableMetadata,
  StoichiometryStructuredTableRowMetadata,
} from 'notebook/integrations/chemistry/StoichiometryStructuredTableAdapter';
import {StructuredTableCustomComponentSlotProps} from 'notebook/structured-tables/StructuredTableConstants';
import {useTableOps} from 'notebook/tables/spreadsheets/TableOpContext';

export interface StoichiometryTableEmbeddedChemicalSketcherProps
  extends StructuredTableCustomComponentSlotProps<
    StoichiometryStructuredTableMetadata,
    StoichiometryStructuredTableRowMetadata
  > {}

/** A chemical sketcher rendered inside a Stoichiometry Structured Table. It can be used to populate the
 * table with reactants and products.
 */
function StoichiometryTableEmbeddedChemicalSketcher(
  props: StoichiometryTableEmbeddedChemicalSketcherProps
): JSX.Element {
  // @ts-expect-error - tableOps to be used
  const tableOps = useTableOps();
  return (
    <div style={{width: '100%', height: '400px', border: '1px solid black'}}>
      This is my embedded chemical sketcher!
    </div>
  );
}

export default memo(StoichiometryTableEmbeddedChemicalSketcher);
